var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"http://img.hxyou.cn/adf/202003/01/220048_31933_1"}}),_c('input',{attrs:{"id":"uploadFileInput","type":"file","accept":"image/*"},on:{"change":_vm.uploadInputchange}})])}
var staticRenderFns = []

export { render, staticRenderFns }